import React from 'react'
import Reflux from 'reflux-react-16'

import {Route} from 'react-router-dom'

import LoginStore from '../../stores/LoginStore.js'
import LoginActions from '../../actions/LoginActions.js'
import {sanitizeRedirect} from '../../utils/redirect.js'

import {Colors, Popup, Stack} from '../../components/UI/index.js'
import AppNav, {layoutStyle, layoutContentStyle} from '../../components/navigation/AppNav.js'
import {customerNavigation} from '../../components/navigation/customerNavigation.js'
import {getNavPosition, subscribeNavPosition} from '../../components/navigation/navPosition.js'
import LoginPopup from '../../components/login/LoginPopup.js'
import {openMfaPopup} from '../../components/login/mfaPopup.js'
import showTwoFactorWarning from '../../components/login/twoFactorWarning.js'
import Orders from './Orders.js'
import Parcels from './Parcels.js'
import Settings from './settings/Settings.js'
import LightSpeedInstall from './lightspeed/Install.js'
import LightSpeedUninstall from './lightspeed/Uninstall.js'
import ShopifyInstall from './shopify/Install.js'
import NotificationsPopup from '../../components/communication/NotificationsPopup.js'
import NotificationsPage from '../../components/communication/NotificationsPage.js'

export default class Layout extends Reflux.Component {
    constructor(props) {
        super(props)

        this.store = LoginStore
    }

    componentDidMount() {
        const {history} = this.props

        document.title = 'Klantportaal'

        LoginActions.loggedIn((loggedIn) => {
            if (!loggedIn) {
                const redirect = sanitizeRedirect(`${history.location.pathname}${history.location.search}`)

                if (redirect) {
                    history.push(`/login?redirect=${encodeURIComponent(redirect)}`)
                } else {
                    history.push('/login')
                }
            } else {
                if (history.location.pathname === '/klant' || history.location.pathname === '/klant/') {
                    if (this.state.user._id) {
                        if (!this.state.user.isCustomer) {
                            history.push('/')
                        } else if (this.state.user?.permissions?.orders || this.state.user?.permissions?.ordersRead) {
                            history.push('/klant/ritten')
                        } else {
                            history.push('/klant/zendingen')
                        }
                    }
                }

                LoginActions.checkNotifications(() => {
                    this.notificationsPopup?.checkIfNewNotification()
                })
            }
        })

        this.unsubscribeNavPosition = subscribeNavPosition(() => this.setState({navPosition: getNavPosition()}))
    }

    componentWillUnmount() {
        super.componentWillUnmount()
        this.unsubscribeNavPosition?.()
    }

    componentDidUpdate(prevProps, prevState) {
        const {history} = this.props

        if (prevState.user !== this.state.user) {
            if (!this.state.user.isCustomer) {
                history.push('/')
            }
        }

        if (history.location.pathname === '/klant' || history.location.pathname === '/klant/') {
            if (!prevState.user._id && this.state.user._id) {
                if (this.state.user?.permissions?.orders || this.state.user?.permissions?.ordersRead) {
                    history.push('/klant/ritten')
                } else {
                    history.push('/klant/zendingen')
                }
            }
        }
    }

    onClickHelp() {
        const {branding} = this.state

        window.open((branding?.manualURLCustomer) || 'https://handleiding.veloyd.nl/docs/introductie-van-het-portaal/', '_blank')
    }

    onClickSwitchAccount() {
        const {accounts, user} = this.state

        this.loginPopup.open(accounts, user, (index) => {
            const account = accounts[index]

            if (account.mfaRequired && !user.is2FASignedIn) {
                if (account.mfaEnabled) {
                    if (account.mfaMethod === 'email') {
                        LoginActions.mailMFACode(null, index, null, (err) => {
                            if (err) {
                                this.popup.setError(err)
                            }
                        })
                    }

                    openMfaPopup(this.popup, {
                        mfaMethod: account.mfaMethod,
                        onLogin: (code) => {
                            LoginActions.switchAccount(index, code, (err) => {
                                if (err) {
                                    this.popup.setError(err)
                                }
                            })
                        }
                    })
                } else {
                    showTwoFactorWarning(this.popup, () => LoginActions.logout())
                }
            } else {
                LoginActions.switchAccount(index, null, (err, reseller) => {
                    if (err) {
                        this.setState({loading: false, error: err})

                        if ((!account.isMessenger && reseller.settings.mfaWebEnabled) || (account.isMessenger && reseller.settings.mfaAppEnabled)) {
                            showTwoFactorWarning(this.popup, () => LoginActions.logout())
                        }
                    }
                })
            }
        })
    }

    onClickLogout() {
        this.popup.open('Uitloggen', 'Weet je zeker dat je wilt uitloggen?', () => LoginActions.logout())
    }

    render() {
        const {reseller, user, accounts, notifications, branding} = this.state
        const {history} = this.props
        const {pathname} = history.location

        const navigation = customerNavigation({
            reseller,
            user,
            accounts,
            pathname,
            onClickHelp: this.onClickHelp.bind(this),
            onClickSwitchAccount: this.onClickSwitchAccount.bind(this),
            onClickLogout: this.onClickLogout.bind(this)
        })

        const navPosition = getNavPosition()

        return (
            <Stack style={{flex: 1, height: '100vh', minWidth: 1366, ...layoutStyle(navPosition)}}>
                <AppNav navigation={navigation} position={navPosition} branding={branding} history={history} />

                <Stack style={{flex: 1, background: Colors.backgroundNeutral, ...layoutContentStyle(navPosition)}}>
                    {user.isCustomer && (user.permissions.orders || user.permissions.ordersRead) &&
                        <Route path='/klant/ritten' render={(props) => <Orders {...props} user={user} reseller={reseller} />} />
                    }
                    {user.isCustomer && user.permissions.parcels &&
                        <Route path='/klant/zendingen' render={(props) => <Parcels {...props} user={user} reseller={reseller} />} />
                    }
                    {user.isCustomer &&
                        <Route path='/klant/instellingen' render={(props) => <Settings {...props} user={user} reseller={reseller} />} />
                    }
                    {user.isCustomer &&
                        <Route path='/klant/lightspeed/install' render={(props) => <LightSpeedInstall {...props} user={user} reseller={reseller} />} />
                    }
                    {user.isCustomer &&
                        <Route path='/klant/lightspeed/uninstall' render={(props) => <LightSpeedUninstall {...props} user={user} reseller={reseller} />} />
                    }
                    {user.isCustomer &&
                        <Route path='/klant/shopify/install' render={(props) => <ShopifyInstall {...props} user={user} reseller={reseller} />} />
                    }
                    {user.isCustomer &&
                        <Route path='/klant/meldingen' render={(props) => <NotificationsPage {...props} showList user={user} notifications={notifications} reseller={reseller} />} />
                    }
                </Stack>

                <LoginPopup ref={(ref) => this.loginPopup = ref} />
                <Popup ref={(ref) => this.popup = ref} />

                <NotificationsPopup
                    user={user}
                    onClickReadNotifications={LoginActions.updateReadNotifications}
                    notifications={notifications}
                    ref={(ref) => this.notificationsPopup = ref}
                />
            </Stack>
        )
    }
}
